export default "__VITE_ASSET__2dJEC9Ia__"